export default __webpack_public_path__ + "static/media/register.af045d0d.svg";